<div *ngIf="type === 1" class="stat-tile" [ngClass]="customClass">
  <div class="kpi-card">

    <!-- HEADER -->
    <div class="kpi-header">
      <div class="kpi-title">{{ title }}</div>

      <div class="kpi-trend" [ngClass]="profit">
        <i class="ri-arrow-up-line" *ngIf="profit === 'up'"></i>
        <i class="ri-arrow-down-line" *ngIf="profit === 'down'"></i>
        <span>{{ percentage }}</span>
      </div>
    </div>

    <!-- VALUE -->
    <div class="kpi-body">
      <span class="kpi-prefix">{{ prefix }}</span>
      <span class="kpi-value">{{ value }}</span>
      <span class="kpi-suffix">{{ suffix }}</span>
    </div>

    <!-- FOOTER -->
    <div class="kpi-footer">
      <span class="kpi-sign">{{ sign }}</span>

      <i
        *ngIf="icon"
        class="kpi-icon {{ icon }} {{ iconcolor }}">
      </i>
    </div>

  </div>
</div>


<!-- TYPE 2 TILE -->
<div class="col" *ngIf="type === 2">
  <div class="py-4 px-3">

    <p class="text text-uppercase fs-13">
      {{ title }}
      <i class="fs-18 float-end align-middle" [ngClass]="{
           'ri-arrow-up-circle-line text-success': profit === 'up',
           'ri-arrow-down-circle-line text-danger': profit === 'down'
         }">
      </i>
    </p>

    <div class="d-flex align-items-center">

      <div class="flex-shrink-0 mx-4">
        <i class="{{ icon }} display-6 {{ iconcolor }}"></i>

        <div class="avatar-md mt-2" *ngIf="SetPic">
          <img [src]="'data:image/png;base64,' + SetPic" class="img-thumbnail rounded-circle" alt="user-img" />
        </div>
      </div>

      <div class="ms-3 d-flex flex-column mx-4">
        <h4>{{ prefix }}</h4>
        <h2 class="mb-0">{{ sign }}</h2>
        <span class="fs-14">{{ value }} {{ percentage }}</span>
        <h4>{{ suffix }}</h4>
      </div>

    </div>
  </div>
</div>